// extracted by mini-css-extract-plugin
module.exports = {"LoadingWideCard":"LoadingWideCard_LoadingWideCard__1mKGP","White":"LoadingWideCard_White__nMaAc","loading":"LoadingWideCard_loading__21wkM"};